const translation = {
  // Navigation
  nav: {
    discover: 'Keşfet',
    messages: 'Mesajlar',
    profile: 'Profil',
    settings: 'Ayarlar',
    logout: 'Çıkış Yap',
  },
  
  // Home/Landing
  home: {
    title: 'Mükemmel Eşini Bul',
    subtitle: 'Dünyanın her yerinden insanlarla tanış. Sonsuza kadar ücretsiz.',
    getStarted: 'Başla',
    features: {
      title: 'Neden Love Connect Globimeet?',
      free: {
        title: 'Tamamen Ücretsiz',
        description: 'Tüm özellikler ücretsiz. Gizli maliyet yok.',
      },
      global: {
        title: 'Küresel Bağlantılar',
        description: 'Her ülkeden insanlarla tanış.',
      },
      safe: {
        title: 'Güvenli ve Emniyetli',
        description: '18+ yaş doğrulaması ve profil fotoğrafı zorunlu.',
      },
      translate: {
        title: 'Otomatik Çeviri',
        description: 'Yerleşik çeviri ile her dilde sohbet et.',
      },
      video: {
        title: 'Sesli ve Görüntülü Arama',
        description: 'Platform üzerinden ücretsiz arama yap.',
      },
      inclusive: {
        title: 'Herkes İçin Kapsayıcı',
        description: 'Tüm cinsiyetler ve yönelimler hoş geldiniz.',
      },
    },
  },
  
  // Auth
  auth: {
    login: 'Giriş Yap',
    register: 'Kayıt Ol',
    email: 'E-posta',
    password: 'Şifre',
    confirmPassword: 'Şifre Tekrar',
    name: 'İsim',
    birthdate: 'Doğum Tarihi',
    gender: 'Cinsiyet',
    lookingFor: 'Arıyorum',
    country: 'Ülke',
    city: 'Şehir',
    profilePhoto: 'Profil Fotoğrafı',
    uploadPhoto: 'Fotoğraf Yükle',
    agreeTerms: 'Şartlar ve Koşulları kabul ediyorum',
    mustBe18: '18 yaşında veya daha büyük olmalısınız',
    photoRequired: 'Profil fotoğrafı zorunludur',
    genders: {
      male: 'Erkek',
      female: 'Kadın',
      gay: 'Gay',
      lesbian: 'Lezbiyen',
      trans: 'Trans',
      other: 'Diğer',
    },
    lookingForOptions: {
      everyone: 'Herkes',
      men: 'Erkekler',
      women: 'Kadınlar',
      friends: 'Arkadaşlık',
      dating: 'Flört',
      serious: 'Ciddi İlişki',
    },
  },
  
  // Discover
  discover: {
    title: 'Keşfet',
    noMoreProfiles: 'Gösterilecek profil kalmadı',
    filters: 'Filtreler',
    ageRange: 'Yaş Aralığı',
    distance: 'Mesafe',
    showMe: 'Bana Göster',
    applyFilters: 'Filtreleri Uygula',
    like: 'Beğen',
    pass: 'Geç',
    itsAMatch: 'Eşleşme!',
    matchMessage: 'Sen ve {name} birbirinizi beğendiniz!',
    sendMessage: 'Mesaj Gönder',
    keepSwiping: 'Kaydırmaya Devam Et',
  },
  
  // Messages
  messages: {
    title: 'Mesajlar',
    noMatches: 'Henüz eşleşme yok',
    startMatching: 'Eşleşme bulmak için kaydırmaya başla',
    typeMessage: 'Bir mesaj yazın...',
    online: 'Çevrimiçi',
    offline: 'Çevrimdışı',
    translate: 'Çevir',
    selectLanguage: 'Dil Seç',
    translateMessages: 'Mesajları Çevir',
    original: 'Orijinal',
    translated: 'Çevrilmiş',
    videoCall: 'Görüntülü Arama',
    voiceCall: 'Sesli Arama',
  },
  
  // Profile
  profile: {
    title: 'Profil',
    editProfile: 'Profili Düzenle',
    about: 'Hakkında',
    interests: 'İlgi Alanları',
    photos: 'Fotoğraflar',
    addPhoto: 'Fotoğraf Ekle',
    deletePhoto: 'Fotoğrafı Sil',
    saveChanges: 'Değişiklikleri Kaydet',
    age: 'Yaş',
    location: 'Konum',
    addInterest: 'İlgi Alanı Ekle',
    bio: 'Hakkımda',
    editBio: 'Hakkımda Düzenle',
  },
  
  // Settings
  settings: {
    title: 'Ayarlar',
    account: 'Hesap Bilgileri',
    privacy: 'Gizlilik',
    notifications: 'Bildirimler',
    preferences: 'Tercihler',
    security: 'Güvenlik',
    help: 'Yardım',
    language: 'Dil',
    
    accountSettings: {
      title: 'Hesap Bilgileri',
      email: 'E-posta Adresi',
      phone: 'Telefon Numarası',
      saveChanges: 'Değişiklikleri Kaydet',
      dangerZone: 'Tehlikeli Bölge',
      deleteAccount: 'Hesabı Sil',
      deleteWarning: 'Bu işlem geri alınamaz. Tüm verileriniz kalıcı olarak silinecektir.',
    },
    
    privacySettings: {
      title: 'Gizlilik Ayarları',
      profileVisibility: 'Profil Görünürlüğü',
      public: 'Herkese Açık',
      matchesOnly: 'Sadece Eşleşmeler',
      private: 'Gizli',
      showOnline: 'Çevrimiçi Durumunu Göster',
      showOnlineDesc: 'Diğer kullanıcılar çevrimiçi olduğunuzu görebilir',
      showDistance: 'Mesafe Bilgisini Göster',
      showDistanceDesc: 'Profilinizde konumunuza olan mesafe görünsün',
    },
    
    notificationSettings: {
      title: 'Bildirim Ayarları',
      emailNotifications: 'E-posta Bildirimleri',
      emailDesc: 'Önemli güncellemeler için e-posta alın',
      pushNotifications: 'Push Bildirimleri',
      pushDesc: 'Mobil cihazınızda bildirim alın',
      matchNotifications: 'Eşleşme Bildirimleri',
      matchDesc: 'Yeni eşleşmeleriniz için bildirim alın',
      messageNotifications: 'Mesaj Bildirimleri',
      messageDesc: 'Yeni mesajlar için bildirim alın',
    },
    
    preferenceSettings: {
      title: 'Arama Tercihleri',
      ageRange: 'Yaş Aralığı',
      maxDistance: 'Maksimum Mesafe',
      showMe: 'Beni Göster',
      everyone: 'Herkese',
      womenOnly: 'Sadece Kadınlara',
      menOnly: 'Sadece Erkeklere',
      savePreferences: 'Tercihleri Kaydet',
    },
    
    securitySettings: {
      title: 'Güvenlik',
      changePassword: 'Şifre Değiştir',
      currentPassword: 'Mevcut Şifre',
      newPassword: 'Yeni Şifre',
      confirmNewPassword: 'Yeni Şifre Tekrar',
      updatePassword: 'Şifreyi Güncelle',
      twoFactor: 'İki Faktörlü Doğrulama',
      twoFactorDesc: 'Hesabınızı daha güvenli hale getirmek için iki faktörlü doğrulamayı etkinleştirin.',
      enable: 'Etkinleştir',
    },
    
    helpSettings: {
      title: 'Yardım ve Destek',
      faq: 'Sık Sorulan Sorular',
      support: 'Destek Ekibi',
      feedback: 'Geri Bildirim Gönder',
      guide: 'Kullanım Kılavuzu',
    },
    
    languageSettings: {
      title: 'Dil Ayarları',
      selectLanguage: 'Dil Seç',
      languages: {
        en: 'English',
        tr: 'Türkçe',
        es: 'Español',
        fr: 'Français',
        de: 'Deutsch',
        it: 'Italiano',
        pt: 'Português',
        ru: 'Русский',
        ar: 'العربية',
        zh: '中文',
        ja: '日本語',
        ko: '한국어',
      },
    },
  },
  
  // Common
  common: {
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    close: 'Kapat',
    confirm: 'Onayla',
    loading: 'Yükleniyor...',
    error: 'Hata',
    success: 'Başarılı',
    km: 'km',
    yearsOld: 'yaşında',
  },
  
  // Footer
  footer: {
    about: 'Hakkımızda',
    privacy: 'Gizlilik Politikası',
    terms: 'Kullanım Şartları',
    contact: 'İletişim',
    copyright: '© 2024 Love Connect Globimeet. Tüm hakları saklıdır.',
  },
  
  // PWA Kurulumu
  installApp: 'LoveConnect Uygulamasını Yükle',
  installDescription: 'Çevrimdışı erişim ve bildirimlerle tam uygulama deneyimi yaşayın',
  installInstructions: 'Aşağıdaki paylaş butonuna dokunun ve "Ana Ekrana Ekle" seçeneğini seçin',
  tapShare: 'Paylaş\'a Dokun',
  addToHome: 'Ana Ekrana Ekle',
  install: 'Yükle',
};

export default translation;
